import {
  Avatar,
  Flex,
  useColorModeValue,
  Text,
  Box,
  Spinner,
} from "@chakra-ui/react";
import { useQuery } from "@tanstack/react-query";
import Card from "components/card/Card";
import { IssuerUserDetailsType } from "../../types/common";
import { request } from "utils/api";
import React from "react";
import { useParams } from "react-router-dom";

const IssuerDetails = () => {
  const { id } = useParams();
  const cardBg = useColorModeValue("secondaryGray.300", "navy.900");
  const textColor = useColorModeValue("secondaryGray.900", "white");
  const { data, isLoading } = useQuery({
    queryKey: ["issuer-details", id],
    queryFn: async () => {
      const response = await request<IssuerUserDetailsType>(
        `/user_reports/${id}/issuer/details`
      );
      return response;
    },
  });
  const reportedDetails = data?.success ? data?.data : null;
  return (
    <Card py="50px" flexDirection="column" w="100%" bg={cardBg} px="0px">
      {isLoading ? (
        <Flex justifyContent="center" alignItems="center" h="100%" w="100%">
          <Spinner size="xl" color={textColor} />
        </Flex>
      ) : (
        <>
          <Flex
            gap="10px"
            flexDir="column"
            alignItems="center"
            textAlign="center"
          >
            <Avatar
              _hover={{ cursor: "pointer" }}
              color="white"
              src={reportedDetails?.details?.issuer?.pp?.public_link}
              bg="#11047A"
              size="2xl"
              w="90px"
              h="90px"
            />
            <Text
              textAlign="center"
              textColor={textColor}
              fontWeight="light"
              flexShrink={0}
              fontSize="25px"
            >
              {reportedDetails?.details?.issuer?.name
                ? reportedDetails?.details?.issuer?.name
                : "-----"}
            </Text>
          </Flex>
          <Flex
            gap="10px"
            flexDir="column"
            alignItems="center"
            textAlign="center"
          >
            <Text
              textAlign="center"
              textColor={textColor}
              fontWeight="light"
              flexShrink={0}
              fontSize="25px"
            >
              {reportedDetails?.details?.issuer?.type
                ? reportedDetails?.details?.issuer?.type
                : "-----"}
            </Text>
          </Flex>
          <Flex
            justifyContent="space-evenly"
            alignItems="center"
            pt="35px"
            h="100%"
            px="20px"
            gap="40px"
            flexWrap="wrap"
          >
            <Box>
              <Text
                textAlign="center"
                textColor={textColor}
                fontWeight="light"
                flexShrink={0}
                fontSize="20px"
              >
                reports created
              </Text>
              <Text
                textAlign="center"
                textColor={textColor}
                fontWeight="light"
                flexShrink={0}
                fontSize="20px"
              >
                {reportedDetails?.reportsCount
                  ? reportedDetails?.reportsCount
                  : "-----"}
              </Text>
            </Box>
            <Box>
              <Text
                textAlign="center"
                textColor={textColor}
                fontWeight="light"
                flexShrink={0}
                fontSize="20px"
              >
                Most frequent reason
              </Text>
              <Text
                textAlign="center"
                textColor={textColor}
                fontWeight="light"
                flexShrink={0}
                fontSize="20px"
              >
                {reportedDetails?.topReasons?.reason
                  ? reportedDetails?.topReasons?.reason
                  : "----"}
                {" ("}
                {reportedDetails?.topReasons?.total}
                {")"}
              </Text>
            </Box>
            <Box>
              <Text
                textAlign="center"
                textColor={textColor}
                fontWeight="light"
                flexShrink={0}
                fontSize="20px"
              >
                got reported
              </Text>
              <Text
                textAlign="center"
                textColor={textColor}
                fontWeight="light"
                flexShrink={0}
                fontSize="20px"
              >
                {reportedDetails?.gotReportedCount
                  ? reportedDetails?.gotReportedCount
                  : 0}
              </Text>
            </Box>
          </Flex>
        </>
      )}
    </Card>
  );
};

export default IssuerDetails;
